import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import { getSubProductConditions } from 'lib/api';
import {
  addExtraDataToDocument,
  getAvailableArrearTables,
} from 'lib/api/factoring';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { cellFormat } from 'lib/designSystem/Table/cellFormat';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import { validateCompanyTypes } from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthState } from 'services/redux/authSlice';

import OperativeInfo from '../../../../../../../../BusinessProfile/Profile/components/Operative';
import ChatWindow from '../../../../../common/chat';
import FilesDialog from '../../../../../common/filesView';
import InvoicesDetailsModule from './components/InvoicesModule';
import FactoringOperationsTab from './components/Operations';
import PaymentModule from './components/PaymentModule';
import FactoringRiskTab from './components/Risk';
import Summary from './components/Summary';
import TopHeader from './components/TopHeader';

export const PAYOUT_AVAILABLE_STAGES = [
  'En giro',
  'Cedida',
  'Activa',
  'Completada',
  'En mora',
];
export const EXECUTED_STAGES = ['Activa', 'Completada'];

export const OPERATIONS_AVAILABLE_STAGES = [
  'Aceptada',
  'Rechazada',
  'Completada',
];

const ShoppingDialogRecieved = (props: any) => {
  const {
    openDatesSelection,
    setOpenDatesSelection,
    setBackwards,
    shoppingCartType,
    openShoppingCart,
    setOpenShoppingCart,
    setUp,
    selectedRequest,
    setSelectedRequest,
    setSuccessOpen,
    setFailureOpen,
    executiveCreating,
    businessId,
    subProduct,
    setSubProduct,
    onlySimulation,
    resetShoppingCart,
    resetRequestToOriginal,
    selectedId,
  } = props;
  const creating =
    !selectedRequest?.status ||
    selectedRequest?.status === 'CREATED' ||
    selectedRequest?.status === 'Creada' ||
    selectedRequest?.status === 'Creando';
  const isDraft = selectedRequest?.status === 'Borrador';
  const [openFiles, setOpenFiles] = useState(false);
  const [startValue, setStartValue] = useState(0);
  const [goToRiskTimes, setGoToRiskTimes] = useState(1);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState<any>({
    advance: 0,
    guaranteeAmount: 0,
    rate: 0,
    arrearRate: 0,
    arrearType: 'lineal',
    arrearTableId: null,
    operationCost: 0,
    amountToApply: 0,
    operationCostComissionFixed: 0,
    operationCostComissionVariablePercentage: 0,
    operationCostComissionVariable: 0,
    expenses: [],
    contactData: onlySimulation ? {} : null,
    selectedDocumentsToApply: [],
    requestDate: null,
    guaranteeObservation: null,
    executive: null,
    fundRate: 0,
  });
  const [documentsToApply, setDocumentsToApply] = useState<any[]>([]);
  const [openCloseModal, setOpenCloseModal] = useState(false);
  const [availableArrearTables, setAvailableArrearTables] = useState<any[]>([]);

  const setUpProductConditions = async () => {
    try {
      const subProductConditions = await getSubProductConditions(dispatch, {
        businessId: selectedRequest.businessIdentifier,
        subProductId: selectedRequest.subProduct,
      });
      setSubProduct({ ...subProduct, conditions: subProductConditions });
      setFormData({
        ...formData,
        advance: subProductConditions.advance,
        rate: subProductConditions.spread + subProductConditions.fundRate,
        arrearRate: subProductConditions.arrearRate,
        operationCostComissionFixed: subProductConditions.operationCostFixed,
        operationCostComissionVariablePercentage:
          subProductConditions.operationCostVariable,
        operationCostComissionVariable:
          (subProductConditions.operationCostVariable / 100) *
          selectedRequest.amount,
        amountToApply: selectedRequest.amountToApply,
        requestDate: selectedRequest.requestDate,
        executive: selectedRequest.executive,
        fundRate: subProductConditions.fundRate,
        spread: subProductConditions.spread,
      });
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const addPreviousDocumentDataToRequest = async () => {
    try {
      const newDocuments = await addExtraDataToDocument(dispatch, {
        documents: selectedRequest.documents,
        attributes: ['ownConfirmation', 'payerSegment'],
      });
      setSelectedRequest({ ...selectedRequest, documents: newDocuments });
    } catch (error) {
      console.error(error);
    }
  };

  const prepareRequestForCreating = async () => {
    setLoading(true);
    if (validateCompanyTypes(user, 'FinancingHub')) {
      await setUpProductConditions();
      await addPreviousDocumentDataToRequest();
    }
    setLoading(false);
  };

  const setUpAvailableArrearTables = async () => {
    const availableArrearTables = await getAvailableArrearTables(dispatch);
    setAvailableArrearTables(availableArrearTables);
  };

  useEffect(() => {
    if (creating) void prepareRequestForCreating();
    void setUpAvailableArrearTables();
  }, []);

  const goToRisk = () => {
    setStartValue(1);
    setGoToRiskTimes(goToRiskTimes + 1);
  };
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const canSeeAllTabs = validateCompanyTypes(user, 'FinancingHub');
  const canPayoutFromAccepted =
    selectedRequest?.status === 'Aceptada' &&
    selectedRequest.subProductCategory !== 'invoice';

  const ImportedModuleLayout = (props: any) => {
    return (
      <div>
        {props.children}
        <DialogActions>
          <CustomButton
            onClick={() => setOpenShoppingCart(false)}
            color="secondary"
            style={{ marginTop: '10px' }}
          >
            {' '}
            Salir{' '}
          </CustomButton>
        </DialogActions>
      </div>
    );
  };

  const tabs = [
    {
      index: 0,
      label: 'Resumen',
      component: (
        <Summary
          subProduct={subProduct}
          setSubProduct={setSubProduct}
          shoppingCartType={shoppingCartType}
          openShoppingCart={openShoppingCart}
          setOpenShoppingCart={setOpenShoppingCart}
          setUp={setUp}
          selectedRequest={selectedRequest}
          setSelectedRequest={setSelectedRequest}
          setSuccessOpen={setSuccessOpen}
          setFailureOpen={setFailureOpen}
          executiveCreating={executiveCreating}
          goToRisk={goToRisk}
          businessId={businessId}
          onlySimulation={onlySimulation}
          openDatesSelection={openDatesSelection}
          setOpenDatesSelection={setOpenDatesSelection}
          setBackwards={setBackwards}
          formData={formData}
          setFormData={setFormData}
          resetRequestToOriginal={resetRequestToOriginal}
          selectedId={selectedId}
          availableArrearTables={availableArrearTables}
          documentsToApply={documentsToApply}
          setDocumentsToApply={setDocumentsToApply}
        />
      ),
    },
  ];

  const financingHubTabs = [
    ...tabs,
    {
      index: 1,
      label: 'Documentos',
      component: (
        <div>
          <InvoicesDetailsModule
            selectedRequest={selectedRequest}
            setSelectedRequest={setSelectedRequest}
            setOpenShoppingCart={setOpenShoppingCart}
            setUp={setUp}
          />
        </div>
      ),
      path: 'documents',
    },
    {
      index: 2,
      label: 'Riesgo',
      disabled: creating || isDraft,
      component: (
        <div>
          <FactoringRiskTab
            selectedRequest={selectedRequest}
            requestType="factoring-request"
            goToRisk={goToRisk}
            setOpenShoppingCart={setOpenShoppingCart}
            setSuccessOpen={setSuccessOpen}
            setFailureOpen={setFailureOpen}
            setUp={setUp}
            selectedId={selectedId}
          />
        </div>
      ),
      path: 'recieved',
    },
    {
      index: 2,
      label: 'Operaciones',
      disabled: creating || isDraft,
      component: (
        <div>
          <FactoringOperationsTab
            selectedRequest={selectedRequest}
            requestType="factoring-request"
            goToRisk={goToRisk}
            setOpenShoppingCart={setOpenShoppingCart}
            setSuccessOpen={setSuccessOpen}
            setFailureOpen={setFailureOpen}
            setUp={setUp}
            selectedId={selectedId}
          />
        </div>
      ),
      path: 'recieved',
    },
    {
      index: 3,
      label: 'Cliente',
      component: (
        <ImportedModuleLayout>
          <OperativeInfo
            businessIdentifier={selectedRequest.businessIdentifier}
          />
        </ImportedModuleLayout>
      ),
      path: 'client',
    },
    {
      index: 4,
      label: 'Giro',
      component: (
        <div>
          <PaymentModule
            selectedRequest={selectedRequest}
            setOpenShoppingCart={setOpenShoppingCart}
            setSuccessOpen={setSuccessOpen}
            setUp={setUp}
            setFailureOpen={setFailureOpen}
          />
        </div>
      ),
      disabled:
        !PAYOUT_AVAILABLE_STAGES.includes(selectedRequest?.status) &&
        !canPayoutFromAccepted,
      path: 'confirmations',
    },
    {
      index: 5,
      label: 'Archivos',
      disabled: creating || isDraft,
      component: (
        <FilesDialog
          openRequest={selectedRequest}
          openFiles={openFiles}
          requestType="factoring"
          setOpenFiles={setOpenFiles}
          setSuccessOpen={setSuccessOpen}
          setFailureOpen={setFailureOpen}
          executiveCreating={executiveCreating}
          setOpenShoppingCart={setOpenShoppingCart}
        />
      ),
      path: 'recieved',
    },
    {
      index: 6,
      label: 'Chat',
      component: (
        <ChatWindow
          selectedRequest={selectedRequest}
          setSuccessOpen={setSuccessOpen}
          setFailureOpen={setFailureOpen}
          requestType="factoring"
          setOpenShoppingCart={setOpenShoppingCart}
        />
      ),
      path: 'recieved',
    },
  ];

  if (selectedRequest && selectedRequest.status === 'REJECTED') {
    financingHubTabs.pop();
  }

  if (executiveCreating) {
    financingHubTabs.pop();
  }

  return (
    <>
      <Dialog maxWidth="xl" fullWidth open={openShoppingCart}>
        <div style={{ padding: 20, minHeight: 200 }}>
          {loading ? (
            <CenteredCircularProgress type="dialog" />
          ) : (
            <EnhancedTab
              title={
                !executiveCreating
                  ? `Solicitud ${cellFormat(selectedRequest?.id, 'numeric-id')}`
                  : 'Nueva solicitud'
              }
              startValue={startValue}
              tabs={!canSeeAllTabs ? tabs : financingHubTabs}
              updater={goToRiskTimes}
              chip={
                <TopHeader
                  selectedRequest={selectedRequest}
                  setOpenCloseModal={setOpenCloseModal}
                />
              }
            />
          )}
        </div>
      </Dialog>
      <Dialog title="Salir de simulador" open={openCloseModal}>
        <DialogContent>
          <Typography variant="h4">
            ¿Estás seguro que deseas salir del simulador?
          </Typography>{' '}
          <Typography variant="body1">
            Podrías perder los cambios realizados.
          </Typography>
        </DialogContent>
        <DialogActions>
          <CustomButton
            onClick={() => setOpenCloseModal(false)}
            color="secondary"
          >
            Cancelar
          </CustomButton>
          <CustomButton
            onClick={() => setOpenShoppingCart(false)}
            color="error"
          >
            Salir
          </CustomButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ShoppingDialogRecieved;
